<script>
    export let name = "";
    export let val = "";
    export let xVal = null;
    $: val = xVal === null ? val : xVal.toString();
    export let noData = false;
</script>

<div class="root">
    <span class="name">{name}</span>
    {#if noData}
        <span class="nullVal">--</span>
    {:else}
        <span class="val">{val}</span>
    {/if}
</div>

<style>
    .root {
        margin: 0.3rem;
    }
    .name {
        font-size: 0.9rem;
        font-weight: 300;
        color: var(--back_D2);
        margin-right: 0.5rem;
    }
    .val {
        font-size: 0.9rem;
        font-weight: 500;
    }
    .nullVal {
        color: var(--back_D2);
        font-size: 1.2rem;
        font-weight: 500;
    }
</style>
